import angular from 'angular';
import WishlistController from "./wishlist.controller";
import WishlistService from "./wishlist.service";

let wishlist = angular
    .module('wishlist', [])
    .controller('WishlistController', WishlistController)
    .service('WishlistService', WishlistService);

export default wishlist;
